import {createSelector} from 'reselect';

const mergeSelectedReducers = () => {
  return {};
};

export const SelectState = createSelector([], mergeSelectedReducers);
